<template>
    <header :class="['site-header', { 'is-scrolled': scrolled }]">
        <nav class="px-4 lg:px-8">
            <div class="flex flex-wrap justify-between items-center mx-auto max-w-screen-xl">
                <!-- Logo -->
                <router-link to="/" class="flex items-center logo-link">
                    <img src="../assets/Logo-Completo-Negro.svg" class="m-3 h-20 sm:h-24" alt="Jeshu logo" />
                </router-link>

                <!-- Botón Agendar Cita para escritorio -->
                <div class="flex items-center lg:order-2">
                    <a href="https://jeshubeauty.setmore.com/"
                        class="hidden lg:inline-flex items-center gap-2 text-white text-base font-semibold tracking-wide px-6 py-2.5 mr-2 rounded-full bg-brand-gradient shadow-brand hover:shadow-brand-lg hover:-translate-y-0.5 transition-all duration-300 ease-smooth focus:outline-none focus-visible:ring-2 focus-visible:ring-purple-custom focus-visible:ring-offset-2">
                        Reservar Cita
                        <img src="../assets/pencil-svgrepo-com2.svg" alt="Calendario" class="w-5 h-5" />
                    </a>

                    <!-- Botón de menú móvil -->
                    <button @click="toggleMobileMenu" type="button"
                        :aria-expanded="mobileMenuOpen"
                        class="inline-flex items-center justify-center w-10 h-10 ml-1 text-white bg-purple-custom rounded-full lg:hidden hover:bg-purple-hover transition-colors duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-purple-custom focus-visible:ring-offset-2">
                        <span class="sr-only">Open main menu</span>
                        <svg v-if="!mobileMenuOpen" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd"></path>
                        </svg>
                        <svg v-else class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.2" d="M6 18L18 6M6 6l12 12"></path>
                        </svg>
                    </button>
                </div>

                <!-- Menú de navegación -->
                <div :class="['mobile-menu', { 'is-open': mobileMenuOpen }]" class="w-full lg:flex lg:w-auto lg:order-1 lg:items-center">
                    <ul class="flex flex-col gap-1 mt-4 lg:flex-row lg:gap-8 lg:mt-0">
                        <li>
                            <router-link to="/" @click="closeMobileMenu" class="nav-link nav-item">Inicio</router-link>
                        </li>
                        <li>
                            <router-link to="/about" @click="closeMobileMenu" class="nav-link nav-item">Quien Soy</router-link>
                        </li>
                        <li>
                            <router-link to="/services" @click="closeMobileMenu" class="nav-link nav-item">Servicios</router-link>
                        </li>
                        <li>
                            <router-link to="/contact" @click="closeMobileMenu" class="nav-link nav-item">Contacto</router-link>
                        </li>
                        <li>
                            <router-link to="/galeria" @click="closeMobileMenu" class="nav-link nav-item">Trabajos</router-link>
                        </li>
                    </ul>

                    <!-- Botón Agendar Cita para menú móvil -->
                    <div class="mt-5 mb-4 lg:hidden px-1">
                        <a href="https://jeshubeauty.setmore.com/" @click="closeMobileMenu"
                            class="inline-flex items-center gap-2 text-white text-sm font-semibold tracking-wide px-5 py-2.5 rounded-full bg-brand-gradient shadow-brand transition-all duration-300 ease-smooth">
                            Reservar cita
                            <img src="../assets/pencil-svgrepo-com2.svg" alt="Calendario" class="w-5 h-5" />
                        </a>
                    </div>
                </div>
            </div>
        </nav>
    </header>
</template>

<script>
export default {
    name: 'HeaderGlobal',
    data() {
        return {
            mobileMenuOpen: false,
            scrolled: false,
        };
    },
    mounted() {
        this.handleScroll();
        window.addEventListener('scroll', this.handleScroll, { passive: true });
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        toggleMobileMenu() {
            this.mobileMenuOpen = !this.mobileMenuOpen;
        },
        closeMobileMenu() {
            this.mobileMenuOpen = false;
        },
        handleScroll() {
            this.scrolled = window.scrollY > 12;
        },
    },
};
</script>

<style scoped>
.site-header {
    position: sticky;
    top: 0;
    z-index: 50;
    background: rgba(255, 255, 255, 0.96);
    transition: background-color 0.35s ease, box-shadow 0.35s ease,
                backdrop-filter 0.35s ease;
}

.site-header.is-scrolled {
    background: rgba(255, 255, 255, 0.82);
    -webkit-backdrop-filter: saturate(160%) blur(14px);
    backdrop-filter: saturate(160%) blur(14px);
    box-shadow: 0 4px 24px rgba(17, 12, 24, 0.08);
}

.logo-link {
    transition: opacity 0.3s ease;
}

.logo-link:hover {
    opacity: 0.85;
}

.nav-item {
    display: inline-block;
    padding: 0.55rem 0.2rem;
    color: #374151;
    font-size: 0.95rem;
    font-weight: 500;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    transition: color 0.3s ease;
}

.nav-item:hover {
    color: #734A91;
}

/* Mobile menu animation */
.mobile-menu {
    overflow: hidden;
    max-height: 0;
    opacity: 0;
    transition: max-height 0.4s cubic-bezier(0.22, 1, 0.36, 1),
                opacity 0.3s ease;
}

.mobile-menu.is-open {
    max-height: 600px;
    opacity: 1;
}

@media (min-width: 1024px) {
    .mobile-menu {
        max-height: none !important;
        opacity: 1 !important;
        overflow: visible;
    }
}
</style>
